import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import OrderAdditionalServicesTable from "./OrderAdditionalServicesTable";
import OrderAdditionalServicesList from "./OrderAdditionalServicesList";

function OrderAdditionalServices() {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery("(max-width:899px)");

  return (
    <>
      <Box className={"flex items-center justify-start mx-4"}>
        <Typography className={"p-2 font-bold smMax:pb-0"}>
          {t("orderTracking.additionalServices.title")}
        </Typography>
      </Box>
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      {!isSmallScreen && <OrderAdditionalServicesTable />}
      {isSmallScreen && <OrderAdditionalServicesList />}
    </>
  );
}

export default OrderAdditionalServices;
